import React from 'react';
import classnames from 'classnames';
import { useTranslation } from '@lt/localization';

import styles from './emptyFacilities.module.css';

const EmptyFacilities = ({ isMobile }): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div
      className={classnames(styles.container, {
        [styles.containerMobile]: isMobile,
      })}
    >
      <div
        className={classnames(styles.header, {
          [styles.mobileHeader]: isMobile,
        })}
      >
        {t('hotel.facilities.empty.header')}
      </div>
      <div className={styles.text}>{t('hotel.facilities.empty.text')}</div>
    </div>
  );
};

export default EmptyFacilities;
